// Added by Sejune Oh on 2020-02-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Component, createRef } from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Intl from '@/helper/Intl'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Component
import TableComponent, { getTableHeaderOption } from '@/components/common/Table'
import { ReactClickEvent } from '@/helper/define'
import { UserCustomInfoProp } from '@/stores/mgmt/user'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface CustomInfoTableCProps {
    elements: Array<DisplableUserCustomInfoProp>
    onRowClick: ReactClickEvent
}

export interface DisplableUserCustomInfoProp extends UserCustomInfoProp {
    delete_btn?: JSX.Element
    index?: number
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class CustomInfoTable extends Component<CustomInfoTableCProps> {
    _headerProps = [
        getTableHeaderOption({
            key: 'key',
            label: Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfotable.column_key' }),
            isSortable: true,
        }),
        getTableHeaderOption({
            key: 'value',
            label: Intl.getIntlText({ id: 'htmljs_react.mgmt.custominfotable.column_value' }),
            isSortable: true,
        }),
        getTableHeaderOption({
            key: 'delete_btn',
            label: ' ',
            isSortable: false,
            type: 'jsx',
        }),
    ]
    _tableRef = createRef<any>()

    render() {
        return (
            <TableComponent
                ref={this._tableRef}
                headerProps={this._headerProps}
                isSortable={true}
                isSelectable={false}
                isPaginationable={false}
                elements={this.props.elements}
                totalCount={this.props.elements.length}
                onRowClick={this.props.onRowClick}
            />
        )
    }

    getData = () => {
        this._tableRef.current!.getData()
    }
}
